import { ICellRendererParams, type ColDef } from 'ag-grid-community';
import { TZDate } from '@date-fns/tz';
import { format } from 'date-fns';
import { getRiskScoreClass } from '@shared/utils/risk-score-class.util';

export const ALL_ASSESSMENTS_PAGE_SIZE = 25;

export const defaultColDef: ColDef = {
  flex: 1,
  tooltip: params => params.value,
};

const formatCreatedDate = (value: string): string => {
  const tzDate = TZDate.tz('Europe/Zurich', value);
  return value ? format(tzDate, 'yyyy-MM-dd HH:mm:ss') : '';
};

export const colDefs: ColDef[] = [
  {
    field: 'id',
    headerTooltip: 'Id',
    maxWidth: 100,
    cellRenderer: (params: ICellRendererParams) => {
      if (params.value !== undefined) {
        return params.value;
      } else {
        return 'Loading...';
      }
    },
  },
  {
    field: 'createdDate',
    valueFormatter: params => formatCreatedDate(params.value),
    tooltip: params => formatCreatedDate(params.value),
    headerTooltip: 'Created Date',
  },
  {
    field: 'company',
    headerTooltip: 'Company',
  },
  {
    field: 'industry',
    headerName: 'Sector',
    headerTooltip: 'Sector',
  },
  {
    field: 'country',
    headerTooltip: 'Country',
  },
  {
    field: 'project',
    headerTooltip: 'Project',
  },
  {
    field: 'sensitivity',
    minWidth: 140,
    maxWidth: 150,
    cellRenderer: (params: { value: string }) => `<span class="risk-chip ${getRiskScoreClass(params.value)}">${params.value ?? ''}</span>`,
    headerTooltip: 'Sensitivity',
  },
  {
    field: 'dealId',
    headerTooltip: 'Deal Id',
  },
  {
    field: 'mainDriver',
    headerTooltip: 'Main Driver',
  },
  {
    field: 'underwritingSource',
    headerTooltip: 'Underwriting Source',
  },
  {
    field: 'createdBy',
    headerTooltip: 'Created By',
  },
];
